// Router
import { NavLink, withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import { updateAuthenticated, updateUser } from "./../../redux/actions/index";
import { ROLE_TYPES } from "../../helpers/roleTypes";

//Styles
import "./SideNav.css";

const SideNav = ({ onCloseSideNav, loggedInUser }) => {
  const { roleTypes } = loggedInUser;

  const displaySubmenu = (id) => {
    const subMenuClassList = document.getElementById(id).children[1].classList;

    if (!subMenuClassList.contains("sub-menu-visible")) {
      return subMenuClassList.add("sub-menu-visible");
    } else {
      return subMenuClassList.remove("sub-menu-visible");
    }
  };

  return (
    <div id="mySidebar" className="SideBar normal-1x SlideInLeft">
      <ul className="side-nav-links">
        {/* Dashboard */}
        {(roleTypes.includes(ROLE_TYPES.GENERAL_DASHBOARD) ||
          roleTypes.includes(ROLE_TYPES.BUSINESS_PERFORMANCE_DASHBOARD)) && (
          <div
            onClick={() => displaySubmenu("dashboard-menu")}
            id="dashboard-menu"
          >
            <li id="dashboard">
              <div className="parent-menu">
                <span className="link-icon mr-3">
                  <i className="ri-dashboard-line"></i>
                </span>
                <span className="menu-title">Dashboard</span>
                <i className="fa fa-angle-down fa-lg arrow-icon"></i>
              </div>
            </li>
            <div className="sub-menu-visible">
              {roleTypes.includes(ROLE_TYPES.GENERAL_DASHBOARD) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/main-dashboard">
                    <span className="link-text">General</span>
                  </NavLink>
                </div>
              )}

              {roleTypes.includes(
                ROLE_TYPES.BUSINESS_PERFORMANCE_DASHBOARD
              ) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/dashboard">
                    <span className="link-text">Business Performance</span>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Loans */}
        {(roleTypes.includes(ROLE_TYPES.CREDIT_VIEWER) ||
          roleTypes.includes(ROLE_TYPES.DISBURSEMENT_INITIATOR) ||
          roleTypes.includes(ROLE_TYPES.REPAYMENT_INITIATOR) ||
          roleTypes.includes(ROLE_TYPES.DEAL_SLIP_APPROVER)) && (
          <div onClick={() => displaySubmenu("loans-menu")} id="loans-menu">
            <li id="loans">
              <div className="parent-menu">
                <span className="link-icon mr-3">
                  <i className="ri-hand-coin-line"></i>
                </span>
                <span className="menu-title">Loans</span>
                <i className="fa fa-angle-down fa-lg arrow-icon"></i>
              </div>
            </li>

            <div className="sub-menu-visible">
              {(roleTypes.includes(ROLE_TYPES.CREDIT_VIEWER) ||
                roleTypes.includes(ROLE_TYPES.DISBURSEMENT_INITIATOR)) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/manage-loans">
                    <span className="link-text">Manage Loans</span>
                  </NavLink>
                </div>
              )}

              {roleTypes.includes(ROLE_TYPES.REPAYMENT_INITIATOR) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/loan-repayment">
                    <span className="link-text">Repayments</span>
                  </NavLink>
                </div>
              )}

              <div className="sub-menu-item">
                <NavLink onClick={onCloseSideNav} to="/credit-bureau">
                  <span className="link-text">Credit Bureau</span>
                </NavLink>
              </div>

              {roleTypes.includes(ROLE_TYPES.DEAL_SLIP_APPROVER) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/pending-slips">
                    <span className="link-text">Pending Deal Slips</span>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        )}
        {/* Approvals */}
        {(roleTypes.includes(ROLE_TYPES.DISBURSEMENT_APPROVER) ||
          roleTypes.includes(ROLE_TYPES.CUSTOMER_INVESTMENT_APPROVER) ||
          roleTypes.includes(ROLE_TYPES.REPAYMENT_APPROVER) ||
          roleTypes.includes(ROLE_TYPES.CREDIT_PRODUCT_APPROVE)) && (
          <div
            onClick={() => displaySubmenu("approvals-menu")}
            id="approvals-menu"
          >
            <li id="approvals">
              <div className="parent-menu">
                <span className="link-icon mr-3">
                  <i className="ri-file-list-3-line"></i>
                </span>
                <span className="menu-title">Approvals</span>
                <i className="fa fa-angle-down fa-lg arrow-icon"></i>
              </div>
            </li>
            <div className="sub-menu-visible">
              {roleTypes.includes(ROLE_TYPES.CREDIT_PRODUCT_APPROVE) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/manage-approvals">
                    <span className="link-text">Set up approvals</span>
                  </NavLink>
                </div>
              )}

              {roleTypes.includes(ROLE_TYPES.INVESTMENT_PRODUCT_VIEWER) &&
                roleTypes.includes(ROLE_TYPES.INVESTMENT_PRODUCT_APPROVER) && (
                  <div className="sub-menu-item">
                    <NavLink onClick={onCloseSideNav} to="/approval-requests">
                      <span className="link-text">
                        Admin Investment Approvals
                      </span>
                    </NavLink>
                  </div>
                )}

              {roleTypes.includes(ROLE_TYPES.DISBURSEMENT_APPROVER) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/approve-loans">
                    <span className="link-text">Loan Disbursement</span>
                  </NavLink>
                </div>
              )}

              {roleTypes.includes(ROLE_TYPES.REPAYMENT_APPROVER) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/repayment-request">
                    <span className="link-text">Loan Repayment</span>
                  </NavLink>
                </div>
              )}

              {roleTypes.includes(ROLE_TYPES.CUSTOMER_INVESTMENT_APPROVER) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/requests">
                    <span className="link-text">
                      Investor Approval Requests
                    </span>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        )}
        {/* Wallet */}
        {(roleTypes.includes(ROLE_TYPES.CUSTOMER_WALLET_INITIATOR) ||
          roleTypes.includes(ROLE_TYPES.CUSTOMER_WALLET_VIEWER) ||
          roleTypes.includes(
            ROLE_TYPES.AGGREGATOR_WALLET_DISBURSEMENT_TRANSACTIONS
          )) && (
          <div onClick={() => displaySubmenu("wallet-menu")} id="wallet-menu">
            <li id="wallet">
              <div className="parent-menu">
                <span className="link-icon mr-3">
                  <i className="ri-wallet-line"></i>
                </span>
                <span className="menu-title">Wallet</span>
                <i className="fa fa-angle-down fa-lg arrow-icon"></i>
              </div>
            </li>
            <div className="sub-menu-visible">
              {(roleTypes.includes(ROLE_TYPES.CUSTOMER_WALLET_INITIATOR) ||
                roleTypes.includes(ROLE_TYPES.CUSTOMER_WALLET_VIEWER) ||
                ROLE_TYPES.WALLET_PROVIDER) &&
                roleTypes.includes(ROLE_TYPES.AGGREGATOR_VIEWER) && (
                  <div className="sub-menu-item">
                    <NavLink onClick={onCloseSideNav} to="/wallet">
                      <span className="link-text">Wallet Provider</span>
                    </NavLink>
                  </div>
                )}

              {roleTypes.includes(
                ROLE_TYPES.AGGREGATOR_WALLET_DISBURSEMENT_TRANSACTIONS
              ) &&
                roleTypes.includes(ROLE_TYPES.AGGREGATOR_VIEWER) && (
                  <div className="sub-menu-item">
                    <NavLink
                      onClick={onCloseSideNav}
                      to="/wallet-disbursement-transactions"
                    >
                      <span className="link-text">
                        Aggregator Wallet Transactions
                      </span>
                    </NavLink>
                  </div>
                )}

              {roleTypes.includes(ROLE_TYPES.CUSTOMER_WALLET_VIEWER) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/company-wallets">
                    <span className="link-text">Company Wallets</span>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        )}
        {/* Investments */}
        {/* There should be another role to signup investor */}
        {(roleTypes.includes(ROLE_TYPES.INVESTMENT_VIEWER) ||
          roleTypes.includes(ROLE_TYPES.INVESTMENT_PRODUCT_SETUP)) &&
          roleTypes.includes(ROLE_TYPES.AGGREGATOR_VIEWER) && (
            <div
              onClick={() => displaySubmenu("investment-menu")}
              id="investment-menu"
            >
              <li id="investment">
                <div className="parent-menu">
                  <span className="link-icon mr-3">
                    <i className="ri-line-chart-line"></i>
                  </span>
                  <span className="menu-title">Investments</span>
                  <i className="fa fa-angle-down fa-lg arrow-icon"></i>
                </div>
              </li>
              <div className="sub-menu-visible">
                {roleTypes.includes(ROLE_TYPES.INVESTMENT_VIEWER) && (
                  <div className="sub-menu-item">
                    <NavLink onClick={onCloseSideNav} to="/investor">
                      <span className="link-text">Investors</span>
                    </NavLink>
                  </div>
                )}

                {roleTypes.includes(ROLE_TYPES.INVESTMENT_VIEWER) && (
                  <div className="sub-menu-item">
                    <NavLink onClick={onCloseSideNav} to="/all-investments">
                      <span className="link-text">Investment Info</span>
                    </NavLink>
                  </div>
                )}

                {(roleTypes.includes(ROLE_TYPES.INVESTMENT_PRODUCT_SETUP) ||
                  roleTypes.includes(ROLE_TYPES.INVESTMENT_VIEWER)) && (
                  <div className="sub-menu-item">
                    <NavLink onClick={onCloseSideNav} to="/investments">
                      <span className="link-text">Investment Funds</span>
                    </NavLink>
                  </div>
                )}

                {roleTypes.includes(ROLE_TYPES.INVESTMENT_VIEWER) && (
                  <div className="sub-menu-item">
                    <NavLink onClick={onCloseSideNav} to="/transactions">
                      <span className="link-text">Investment Transactions</span>
                    </NavLink>
                  </div>
                )}
              </div>
            </div>
          )}

        {/* Aggregators */}
        {(roleTypes.includes(ROLE_TYPES.AGGREGATOR_ONBOARDING_VIEWER) ||
          roleTypes.includes(ROLE_TYPES.AGGREGATOR_VIEWER) ||
          roleTypes.includes(ROLE_TYPES.CREDIT_PRODUCT_SETUP) ||
          roleTypes.includes(ROLE_TYPES.CREDIT_PRODUCT_VIEWER) ||
          roleTypes.includes(ROLE_TYPES.LEGAL_ONBOARDING_APPROVER) ||
          roleTypes.includes(ROLE_TYPES.CREDIT_ONBOARDING_APPROVER) ||
          roleTypes.includes(ROLE_TYPES.GLOBAL_WAITLIST)) &&
          roleTypes.includes(ROLE_TYPES.AGGREGATOR_VIEWER) && (
            <div
              onClick={() => displaySubmenu("aggregator-menu")}
              id="aggregator-menu"
            >
              <li id="aggregator">
                <div className="parent-menu">
                  <span className="link-icon mr-3">
                    <i className="ri-group-line"></i>
                  </span>
                  <span className="menu-title">Aggregators</span>
                  <i className="fa fa-angle-down fa-lg arrow-icon"></i>
                </div>
              </li>
              <div className="sub-menu-visible">
                {roleTypes.includes(ROLE_TYPES.AGGREGATOR_VIEWER) && (
                  <div className="sub-menu-item">
                    <NavLink onClick={onCloseSideNav} to="/manage-ecosystems">
                      <span className="link-text">Manage Aggregators</span>
                    </NavLink>
                  </div>
                )}

                {roleTypes.includes(
                  ROLE_TYPES.AGGREGATOR_ONBOARDING_VIEWER
                ) && (
                  <div className="sub-menu-item">
                    <NavLink
                      onClick={onCloseSideNav}
                      to="/aggregator-onboarding"
                    >
                      <span className="link-text">Onboarding</span>
                    </NavLink>
                  </div>
                )}

                {roleTypes.includes(ROLE_TYPES.GLOBAL_WAITLIST) && (
                  <div className="sub-menu-item">
                    <NavLink
                      onClick={onCloseSideNav}
                      to="/aggregator-global-waitlist"
                    >
                      <span className="link-text">Global Waitlist</span>
                    </NavLink>
                  </div>
                )}
              </div>
            </div>
          )}
        {/* Set Up */}
        {(roleTypes.includes(ROLE_TYPES.USER_CREATION_INITIATOR) ||
          (roleTypes.includes(ROLE_TYPES.CREDIT_PRODUCT_VIEWER) &&
            roleTypes.includes(ROLE_TYPES.CREDIT_PRODUCT_SETUP)) ||
          roleTypes.includes(ROLE_TYPES.GLOBAL_SETTINGS)) &&
          roleTypes.includes(ROLE_TYPES.AGGREGATOR_VIEWER) && (
            <div onClick={() => displaySubmenu("setup-menu")} id="setup-menu">
              <li id="setup">
                <div className="parent-menu">
                  <span className="link-icon mr-3">
                    <i className="ri-settings-2-line"></i>
                  </span>
                  <span className="menu-title">Setup</span>
                  <i className="fa fa-angle-down fa-lg arrow-icon"></i>
                </div>
              </li>

              <div className="sub-menu-visible">
                {roleTypes.includes(ROLE_TYPES.USER_CREATION_INITIATOR) && (
                  <div className="sub-menu-item">
                    <NavLink
                      onClick={onCloseSideNav}
                      to="/manage-roles-and-users"
                    >
                      <span className="link-text">User Management</span>
                    </NavLink>
                  </div>
                )}

                {roleTypes.includes(ROLE_TYPES.GLOBAL_SETTINGS) && (
                  <div className="sub-menu-item">
                    <NavLink onClick={onCloseSideNav} to="/settings">
                      <span className="link-text">Settings</span>
                    </NavLink>
                  </div>
                )}

                {roleTypes.includes(ROLE_TYPES.CREDIT_PRODUCT_SETUP) &&
                  roleTypes.includes(ROLE_TYPES.CREDIT_PRODUCT_VIEWER) &&
                  roleTypes.includes(ROLE_TYPES.AGGREGATOR_VIEWER) && (
                    <div className="sub-menu-item">
                      <NavLink onClick={onCloseSideNav} to="/product-setup">
                        <span className="link-text">Product Setup</span>
                      </NavLink>
                    </div>
                  )}
              </div>
            </div>
          )}
        {/* Reports */}
        {(roleTypes.includes(ROLE_TYPES.STANDARD_LOAN_REPORT) ||
          roleTypes.includes(ROLE_TYPES.LOAN_REPAYMENT_REPORT) ||
          roleTypes.includes(ROLE_TYPES.AUDIT_TRAIL)) && (
          <div onClick={() => displaySubmenu("report-menu")} id="report-menu">
            <li id="report">
              <div className="parent-menu">
                <span className="link-icon mr-3">
                  <i className="ri-file-list-line"></i>
                </span>
                <span className="menu-title">Reports</span>
                <i className="fa fa-angle-down fa-lg arrow-icon"></i>
              </div>
            </li>
            <div className="sub-menu-visible">
              <div className="sub-menu-item">
                <NavLink onClick={onCloseSideNav} to="/main-report">
                  <span className="link-text">Standard Loan Report</span>
                </NavLink>
              </div>

              {roleTypes.includes(ROLE_TYPES.LOAN_REPAYMENT_REPORT) && (
                <div className="sub-menu-item">
                  <NavLink
                    onClick={onCloseSideNav}
                    to="/loan-repayment-reports"
                  >
                    <span className="link-text">Loan Repayment Report</span>
                  </NavLink>
                </div>
              )}

              {roleTypes.includes(ROLE_TYPES.STANDARD_LOAN_REPORT) && (
                <div className="sub-menu-item">
                  <NavLink
                    onClick={onCloseSideNav}
                    to="/loan-income-interest-reports"
                  >
                    <span className="link-text">Income Interest Report</span>
                  </NavLink>
                </div>
              )}

              {roleTypes.includes(ROLE_TYPES.AUDIT_TRAIL) && (
                <div className="sub-menu-item">
                  <NavLink onClick={onCloseSideNav} to="/audit-trail">
                    <span className="link-text">Audit/Trail</span>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Messaging */}
        {(roleTypes.includes(ROLE_TYPES.NOTIFICATION_SETUP) ||
          roleTypes.includes(ROLE_TYPES.NOTIFICATION_VIEWER)) && (
          <div
            onClick={() => displaySubmenu("messaging-menu")}
            id="messaging-menu"
          >
            <li id="messaging">
              <div className="parent-menu">
                <span className="link-icon mr-3">
                  <i className="ri-global-line"></i>
                </span>
                <span className="menu-title">Messaging</span>
                <i className="fa fa-angle-down fa-lg arrow-icon"></i>
              </div>
            </li>
            <div className="sub-menu-visible">
              <div className="sub-menu-item">
                <NavLink onClick={onCloseSideNav} to="/messaging">
                  <span className="link-text">Send Notification</span>
                </NavLink>
              </div>

              <div className="sub-menu-item">
                <NavLink onClick={onCloseSideNav} to="/birthday-notifications">
                  <span className="link-text">Birthday Notifications</span>
                </NavLink>
              </div>
            </div>
          </div>
        )}
      </ul>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { isAuthenticated, loggedInUser } = state.authReducer;
  return {
    isAuthenticated,
    loggedInUser,
  };
};

export default withRouter(
  connect(mapStateToProps, { updateAuthenticated, updateUser })(SideNav)
);
